const traning_assistant_routes = {
      path: "/instructorAssistant",
      name: "InstructorAssistant",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        {
          path: "class",
          component: () => import('@/views/training_assistant/class-list'),
          meta: {requiresAuth: true},
        },
        {
          path: "tea_cd",
          component: () => import('@/views/training_assistant/class-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "won",
          component: () => import('@/views/training_teacher/Wonderful'),
          meta: {requiresAuth: true},
        },
      ]
    }

export default traning_assistant_routes;
